module.exports = __webpack_public_path__ + "img/default_layout_mobile.c4e7593f.png";